export class SvrConf {
  activeProfile?: string = 'prod';
  userAgent?: string = '';
  iscrawler?: boolean = false;
}

export interface IfSvrConf extends SvrConf {
}
